import {AfterContentInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {LinkRef} from '@kion/data-models';

export interface DropDownOption {
  key: any,
  value: string,
  selected: boolean
  linkRef?: LinkRef
}

export interface DropDownIcon {
  icon: string,
  title: string,
  alt: string
}

@Component({
  selector: 'kion-drop-down',
  templateUrl: './drop-down.component.html',
  styleUrls: ['./drop-down.component.scss']
})
export class DropDownComponent implements AfterContentInit {

  //drop down arrow is shown by default
  @Input() showArrowIcon = true;
  //DropDown options set by interface, default empty array
  @Input() options: DropDownOption[] = [];
  //title
  @Input() title: string;
  //default false, if false show drop down on hover
  @Input() showDropDownOnClick: boolean;
  //default no drop down icon set
  @Input() icon: DropDownIcon;
  //default link if options are empty
  @Input() defaultLink: string | LinkRef = null;
  //show selected option
  @Input() showSelectedOption: true;
  // define the position where the selected option should be shown
  @Input() selectedOptionPosition: 'before' | 'behind' = 'before';

  @Input() width: number;

  @Input() parent?: HTMLDivElement;

  // tslint:disable-next-line:no-output-rename
  @Output('selected') optionSelectedEmitter: EventEmitter<DropDownOption> = new EventEmitter<DropDownOption>();

  @ViewChild('dropDown') dropDown: ElementRef;
  @ViewChild('dropDownOption') dropDownOption: ElementRef;

  directionY = 'down';
  directionX = 'right';
  topCalc: number;
  leftCalc: number;

  constructor() {
  }

  get selectedOption(): DropDownOption {
    return this.options?.find(option => option.selected);
  }

  get topPosition(): string {
    if (this.directionY === 'upper') {
      return '-' + this.topCalc + '%'
    }
    return '35px';
  }

  //show dropDown options on click

  get leftPosition(): string {
    if (this.directionX === 'left') {
      return '0';
    }
    return 'auto';
  }

  ngAfterContentInit(): void {
    this.calculatePosition();
    //TODO: if mobile always show on click true !
  }

  //only works if showDropDownOnClick is set to true
  showOnClick(): void {
    this.calculatePosition();
    if (this.showDropDownOnClick) {
      const dropDown = this.dropDown.nativeElement as HTMLElement;
      if (dropDown.classList.contains('show-on-click')) {
        dropDown.classList.remove('show-on-click');
        dropDown.classList.add('hide-on-click');
        return;
      }
      dropDown.classList.add('show-on-click');
      dropDown.classList.remove('hide-on-click')
    }
  }

  optionSelected(option: DropDownOption): void {
    this.optionSelectedEmitter.emit(option);
  }

  calculatePosition(): void {
    if (this.options) {
      this.topCalc = (this.options.length * 100) + 100;
      if (this.dropDown) {
        const bodyRect = document.body.getBoundingClientRect();
        const elementRect = this.dropDownOption.nativeElement.getBoundingClientRect();
        if (this.parent) {
          this.width = this.parent.clientWidth
        }
        const elementYOffset = elementRect.top - bodyRect.top;
        const elementBottom = elementYOffset + elementRect.height;
        const elementXOffset = elementRect.left - bodyRect.left;
        const elementRight = elementXOffset + elementRect.width;
        this.leftCalc = elementRect.width;
        const bodyWidth = document.body.clientWidth;
        const bodyHeight = document.body.clientHeight;
        this.directionY = elementBottom >= bodyHeight ? 'upper' : 'down';
        this.directionX = elementRight >= bodyWidth ? 'left' : 'right';
      }
    }
  }

  hideDropDown() {
    const dropDown = this.dropDown.nativeElement as HTMLElement;
    dropDown.classList.add('show-on-click');
    dropDown.classList.remove('hide-on-click')
  }
}
